import styled from "styled-components";
import { motion } from "framer-motion";

import {SideContainerInterface} from "./SideContainerInterface";

import colors from "../../assets/css/colors";

const SideContainer = styled(motion.div)`
  display: ${(p: SideContainerInterface) => (p.visible ? "flex" : "none")};
  border-left-style: solid;
  border-left-width: 2px;
  border-left-color: ${colors.sideBarBorder};

  overflow-y: scroll;

  ::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 600px){
    border: none;
    z-index:1;
  }

  @media (max-width: 992px){
    height: ${(p: SideContainerInterface) => p.visible ? "100vh" : "none"};
    }

`;

export default SideContainer;
